export class WidgetComponentApi {
    constructor() {
        this.triggerAction = (source) => {
            this.fireEvent("triggeraction", source);
        };
        this.getTheme = () => {
            this.fireEvent("gettheme");
            return this.currentTheme;
        };
        this.updateTheme = (theme) => {
            if (theme === this.currentTheme) {
                return;
            }
            this.currentTheme = theme;
            this.fireEvent("themechanged", this.currentTheme);
        };
        this._eventListeners = new Map();
    }
    addEventListener(eventName, listener) {
        const listeners = this._eventListeners.get(eventName);
        if (listeners) {
            listeners.push(listener);
        }
        else {
            this._eventListeners.set(eventName, [listener]);
        }
    }
    removeEventListener(eventName, listener) {
        const listeners = this._eventListeners.get(eventName);
        if (listeners) {
            let index = listeners.indexOf(listener);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        }
    }
    fireEvent(eventName, data) {
        const listeners = this._eventListeners.get(eventName);
        if (!listeners) {
            return;
        }
        for (let index = 0; index < listeners.length; index++) {
            if (listeners[index]) {
                listeners[index](data);
            }
        }
    }
}
